import { EventEmitter } from '@angular/core';

/* Mixin implementation (To copy to the file implementing the mixin)
    // Alert mixin requirements
    alertsAdded: IU2000_Alert[];
    alertAdded$: EventEmitter<IU2000_Alert>;
    alertUpdated$: EventEmitter<IU2000_Alert>
    alertsCleared$: EventEmitter<any>;
    initAlert: () => void;
    addAlert: (alert: IU2000_Alert) => void;
    updateAlert: (alert: IU2000_Alert) => void;
    clearAlerts: () => void;
*/

export class U2000_AlertServiceMixin {
    alertsAdded: IU2000_Alert[];
    alertAdded$: EventEmitter<IU2000_Alert>;
    alertUpdated$: EventEmitter<IU2000_Alert>;
    alertsCleared$: EventEmitter<any>;

    initAlert() {
        this.alertsAdded = [];
        this.alertAdded$ = new EventEmitter();
        this.alertUpdated$ = new EventEmitter();
        this.alertsCleared$ = new EventEmitter();
    }

    addAlert(alert: IU2000_Alert) {
        if (this.alertAdded$.observers.length > 0) {
            this.alertAdded$.emit(alert);
        } else {
            this.alertsAdded.push(alert);
        }
    }

    updateAlert(alert: IU2000_Alert) {
        this.alertUpdated$.emit(alert);
    }

    clearAlerts() {
        this.alertsCleared$.emit();
        this.alertsAdded = [];
    }
}
